module.exports = __webpack_public_path__ + "static/media/left-arrows-couple.8a107fdc.png";